import type { Chapter } from './types.ts';
import { loadSignature } from './chapters/registry.ts';

export function setupSignatureLoader(chapters: Chapter[]): void {
  const byNumber = new Map<number, Chapter>();
  for (const ch of chapters) byNumber.set(ch.number, ch);

  const mounted = new WeakSet<HTMLElement>();

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        const article = entry.target as HTMLElement;
        if (mounted.has(article)) continue;

        const num = Number(article.dataset['chapter']);
        const chapter = byNumber.get(num);
        if (!chapter) continue;

        mounted.add(article);
        void (async () => {
          const mount = await loadSignature(chapter.signatureModule);
          if (!mount) {
            mounted.delete(article);
            return;
          }
          const host = document.createElement('div');
          host.className = 'signature';
          article.appendChild(host);
          try {
            mount(host, chapter);
          } catch (err) {
            console.error(`signature ${chapter.signatureModule} failed`, err);
          }
        })();
      }
    },
    { rootMargin: '300px 0px' },
  );

  document.querySelectorAll<HTMLElement>('.chapter').forEach((el) => observer.observe(el));
}
